import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Shield, ChevronRight } from 'lucide-react';
import SEO from '../components/SEO';

export const Terms = () => {
  const { t } = useTranslation();

  const sections = Array.from({ length: 10 }, (_, i) => i + 1);

  return (
    <div className="pt-24 pb-12 px-4 max-w-4xl mx-auto bg-white dark:bg-gray-900 min-h-screen">
      <SEO
        title={`${t('navigation.legal.terms') || 'Terms'} – Victor Lazari`}
        description={t('terms.title') as string}
        canonical={"https://victorlazari.com/terms"}
        image={"https://raw.githubusercontent.com/VictorLazari-lab/victorlazari.com/VictorLazari-Media/varienda%20minimalist%20logo.png"}
        type="website"
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h1 className="text-4xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-blue-500 dark:from-cyan-300 dark:to-blue-400 flex items-center justify-center gap-3">
          <Shield className="w-10 h-10" />
          {t('terms.title')}
        </h1>
      </motion.div>

      <div className="space-y-8">
        {sections.map((section) => {
          // Try to get items, default to empty array if not found
          const items = t(`terms.section${section}.items`, { returnObjects: true, defaultValue: [] });
          
          return (
            <motion.section
              key={section}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="bg-white dark:bg-gray-800/50 rounded-lg p-6 backdrop-blur-sm border border-slate-200 dark:border-cyan-400/20 shadow-sm"
            >
              <h2 className="text-xl font-semibold text-cyan-600 dark:text-cyan-400 mb-4">
                {t(`terms.section${section}.title`)}
              </h2>
              
              <p className="text-slate-700 dark:text-gray-300 mb-4">
                {t(`terms.section${section}.content`)}
              </p>

              {Array.isArray(items) && items.length > 0 && (
                <ul className="space-y-2">
                  {items.map((item: string, index: number) => (
                    <li key={index} className="flex items-start gap-2 text-slate-600 dark:text-gray-300">
                      <ChevronRight className="w-5 h-5 text-cyan-600 dark:text-cyan-400 mt-1 flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.section>
          );
        })}

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm text-slate-500 dark:text-gray-400 text-center mt-8"
        >
          {t('terms.lastUpdated')}
        </motion.p>
      </div>
    </div>
  );
};